import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Copyright: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M15 9.4a4 4 0 1 0 0 5.246' }],
  ],
];

export default Copyright;
